import { FC, useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Switch, TextField } from '@mui/material';

import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import MobileAppHandlerCommand from '../../../services/command/mobileapphandler/MobileAppHandlerCommand.services';

interface IProps {
    selectedRow?: any;
    open?: boolean;
    onClose?: any;
    refresh?: any;
}
export const SCUIMPAppHandlerDialog: FC<IProps> = ({ selectedRow, open = false, onClose, refresh }) => {
    const [android_active, setAndroid_Active] = useState(false);
    const [ios_active, setIos_Active] = useState(false);
    const [linkName, setLinkName] = useState('');
    const [name, setName] = useState('');
    useEffect(() => {
        setLinkName(selectedRow ? selectedRow?.link : '');
        setIos_Active(selectedRow?.ios_active ? selectedRow.ios_active : false);
        setAndroid_Active(selectedRow?.android_active ? selectedRow.android_active : false);
        setName(selectedRow ? selectedRow?.name : '');
    }, [selectedRow]);
    const handleChangeName = (event: any) => {
        setName(event.target.value);
    };
    const handleChangeLink = (event: any) => {
        setLinkName(event.target.value);
    };

    const { t } = useTranslation();

    const UpdateMobilHandler = async () => {
        let params = {
            id: selectedRow.id,
            Name: name,
            Android_Active: android_active,
            Ios_Active: ios_active,
            Link: linkName,
        };
        if (name && name.trim().length > 0 && linkName && linkName.trim().length > 0) {
            MobileAppHandlerCommand.PutMobileAppHandler(params)
                .then((_res: any) => {
                    refresh();
                    onClose();
                    Swal.fire(t('general.updated'), ' ', 'success');
                })
                .catch((error: any) => {
                    console.log('Hata :>> ', error);
                });
        } else {
            Swal.fire(t('mobileApp.noEmpty'), ' ', 'error');
        }
    };
    const CreateMobilHandler = async () => {
        let params = {
            Name: name,
            Android_Active: android_active,
            Ios_Active: ios_active,
            Link: linkName,
        };

        if (name && name.trim().length > 0 && linkName && linkName.trim().length > 0) {
            MobileAppHandlerCommand.CreateMobileAppHandler(params)
                .then((_res: any) => {
                    refresh();
                    onClose();
                    Swal.fire(t('general.added'), ' ', 'success');
                })
                .catch((error: any) => {
                    console.log('Hata :>> ', error);
                })
                .finally(() => {});
        } else {
            Swal.fire(t('mobileApp.noEmpty'), ' ', 'error');
        }
        //:Swal.fire(t('general.emptyFieldControlText'), " ", "error");

        setAndroid_Active(false);
        setIos_Active(false);
    };

    const submitHandler = (event: any) => {
        event.preventDefault();
        CreateMobilHandler();
    };
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Mobile Panel Handler</DialogTitle>
            <form onSubmit={submitHandler}>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label={t('mobileApp.parameterName')}
                        fullWidth
                        variant="standard"
                        defaultValue={selectedRow?.name}
                        onChange={handleChangeName}
                    />

                    <TextField
                        margin="dense"
                        id="link"
                        label="Link"
                        fullWidth
                        variant="standard"
                        defaultValue={selectedRow?.link}
                        onChange={handleChangeLink}
                    />

                    <b> Android </b>

                    <Switch
                        checked={android_active}
                        onClick={() => setAndroid_Active((prevRefreshing) => !prevRefreshing)}
                        onChange={(e) => {
                            setAndroid_Active(e.target.checked);
                        }}
                    />

                    <b> IOS </b>

                    <Switch
                        checked={ios_active}
                        onClick={() => setIos_Active((prevRefreshing) => !prevRefreshing)}
                        onChange={(e) => {
                            setIos_Active(e.target.checked);
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    {selectedRow?.id ? (
                        <Button onClick={UpdateMobilHandler}>{t('general.update')}</Button>
                    ) : (
                        <Button type="submit">{t('general.save')} </Button>
                    )}
                    <Button onClick={onClose}>{t('general.cancel')} </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};
